module.exports = __webpack_public_path__ + "img/item-2.cf93c17.png";